import { render, staticRenderFns } from "./purchase-price.vue?vue&type=template&id=10fbdc9d"
import script from "./purchase-price.vue?vue&type=script&lang=js"
export * from "./purchase-price.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports